module.exports = __webpack_public_path__ + "img/zhongjie.defea60c.png";